export default {
  BusinessStockSynchronizationAdd: {
    title: '基础信息',
    titleBtn: '选择逻辑仓',
    code: '逻辑数据同步单号',
    codeText: '系统自动生成',
    logicBinCode: '逻辑仓编码',
    codeSelect: '请选择逻辑仓',
    name: '逻辑仓名称',
    nameText: '请选择逻辑仓',
    commodityDetails: '商品明细',
    selectProduct: '选择商品',
    delProduct: '删除商品',
    num: '调整差异数量',
    msgWarning1: '请先选择逻辑仓',
    msgWarning2: '请先选择商品',
    msgWarning3: '请将 调整类型 和 差异数量(不能为0) 填写完整',
  }
};
